import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Tooltip } from 'antd'
import styled from 'styled-components'

import { colours } from '@qflow/theme'

import { SideBar, icons } from 'portal/lib/primitives'

export function ReportsSidebarButton({ reportsUri }) {
  const isCollapsed = useSelector(state => state.ui.data.sidebarCollapsed)

  return isCollapsed ? (
    <Tooltip title="Reports" placement="right">
      <StyledNavLink id="ReportsSideBarButton" to={reportsUri}>
        <icons.Reports colour="currentColor" />
      </StyledNavLink>
    </Tooltip>
  ) : (
    <SideBar.NavButton
      id="ReportsSideBarButton"
      to={reportsUri}
      Icon={icons.Reports}
      noWrapper={true}
      minimalMargin={true}
    >
      <ButtonContent>
        <div>Reports</div>
        <NewBadge>NEW</NewBadge>
      </ButtonContent>
    </SideBar.NavButton>
  )
}

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 6px;
  margin: -0.5rem -0.25rem 0;
  padding: 8px;
  width: 34px;
  color: #ffffff;
  opacity: 0.8;

  &:hover:not(.active) {
    opacity: 1;
    color: #ffffff;
  }

  &.active {
    color: ${colours.TEAL};
    background-color: rgba(255, 255, 255, 0.1) !important;
    opacity: 1;
  }
`

const ButtonContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: SPACE-BETWEEN;
  gap: 8px;
`

const NewBadge = styled.span`
  background-color: ${colours.TEAL};
  color: white;
  font-size: 0.625rem;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 7px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`
